import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, EMPTY, Observable } from 'rxjs';
import { BACKEND_URL, ORGANIZATION_REQUEST_PREFIX } from '@data-terminal/data-access/injection-tokens';
import { DCNotificationRequest, DCNotificationResponse } from '@data-terminal/shared-models/notification';

@Injectable({
    providedIn: 'root',
})
export class NotificationSendingApiService {
    private readonly http = inject(HttpClient);
    private readonly backendUrl = inject(BACKEND_URL);
    private readonly orgRequestPrefix = inject(ORGANIZATION_REQUEST_PREFIX);

    private readonly NOTIFICATION_EVENT_URL = `${this.backendUrl}${this.orgRequestPrefix}notifications`;

    public sendNotificationEvent(body: DCNotificationRequest): Observable<DCNotificationResponse> {
        return this.http.post<DCNotificationResponse>(this.NOTIFICATION_EVENT_URL, body).pipe(catchError(() => EMPTY));
    }
}
